import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import styles from './loaderButton.module.scss';

export default memo(function LoaderButton(props) {
    const [t] = useTranslation(props.dictionary);

    return (
        <div className={styles.loaderButton}>
            <Button
                className={styles.loginButton}
                disabled={props.inProgress || props.disabled}
                onClick={props.onClick}
                type="submit"
                variant="contained"
            >
                {t(`${props.dictionary}:${props.text}`)}
            </Button>
            {props.inProgress && <CircularProgress size={24} className={styles.loading} />}
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.dictionary === nextProps.dictionary &&
        prevProps.inProgress === nextProps.inProgress &&
        prevProps.disabled === nextProps.disabled &&
        prevProps.text === nextProps.text &&
        prevProps.onClick === nextProps.onClick
);
